<div #childModal="bs-modal" aria-hidden="true" aria-labelledby="mySmallModalLabel" bsModal class="modal fade"
     role="dialog" tabindex="-1">

  <!-- ✅ changed modal-xl → custom-modal -->
  <div class="modal-dialog custom-modal">
    <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title" translate>T_COLLABORATIVE_SHARE_TITLE</h4>
        <div #trancludedTitle>
          <ng-content select="[modal-title]"></ng-content>
        </div>
      </div>

      <div *ngIf="loading;else bodyForm" class="body-invitation loading-spinner">
        <app-spinner [sizeClass]="'medium'">
          <div class="loadingMessage" translate>
            T_COLLABORATIVE_LOADING_INVITATION
          </div>
        </app-spinner>
      </div>

      <ng-template #bodyForm>
        <div class="modal-body">
          <form [formGroup]="form" class="form-horizontal">

            <!-- Share space name -->
            <div class="form-group has-feedback row">
              <label class="col-3 control-label text-left field-mandatory"
                     for="shareSpaceName"
                     translate>
                T_COLLABORATIVE_SHARE_NAME_SPACE
              </label>

              <div class="col-9">
                <input [(ngModel)]="shareSpaceName"
                       [ngClass]="{'red-border-class': form.get('shareSpaceName').hasError('required') || form.get('shareSpaceName').hasError('pattern')}"
                       class="field form-control"
                       formControlName="shareSpaceName"
                       id="shareSpaceName"
                       maxlength="30"
                       type="text" />

                <div *ngIf="form.get('shareSpaceName').hasError('required')">
                  <span class="input-error" translate>T_FIELD_REQUIRED</span>
                </div>

                <div *ngIf="form.get('shareSpaceName').hasError('pattern')">
                  <span class="input-error" translate>T_FIELD_PATTERN_ERROR</span>
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="form-group has-feedback row">
              <label class="col-3 control-label text-left field-mandatory"
                     for="mailAddress"
                     translate>
                T_COLLABORATIVE_SHARE_EMAIL
                <span class="se-icons info"
                      container="body"
                      tooltip="{{'T_SHARE_EMAIL_TOOLTIP' | translate}}">
                  information_circle
                </span>
              </label>

              <div class="col-9">
                <input [(ngModel)]="mailAddress"
                       [ngClass]="{'red-border-class': form.get('mailAddress').hasError('required') || form.get('mailAddress').hasError('pattern')}"
                       class="field form-control"
                       formControlName="mailAddress"
                       id="mailAddress"
                       type="text" />

                <div *ngIf="form.get('mailAddress').hasError('required') || form.get('mailAddress').hasError('pattern')">
                  <span *ngIf="form.get('mailAddress').hasError('required')"
                        class="input-error"
                        translate>
                    T_FIELD_REQUIRED
                  </span>

                  <span *ngIf="!form.get('mailAddress').hasError('required') && form.get('mailAddress').hasError('pattern')"
                        class="input-error"
                        translate>
                    T_EMAIL_EMAIL_REQUIRED
                  </span>
                </div>
              </div>
            </div>

            <!-- Rights -->
            <div class="form-group has-feedback row">
              <label class="col-3 control-label text-left" translate>
                T_COLLABORATIVE_SHARE_RIGHTS
                <span class="se-icons info"
                      container="body"
                      tooltip="{{'T_SHARE_RIGHTS_TOOLTIP' | translate}}">
                  information_circle
                </span>
              </label>

              <div class="col-9">
                <label class="radio-inline">
                  <input [(ngModel)]="rightToEdit"
                         [value]="false"
                         class="pointer"
                         formControlName="rightToEdit"
                         type="radio">

                  <img *ngIf="!rightToEdit"
                       class="radioBtn"
                       src="./assets/images/icons/radio.svg"/>

                  <img *ngIf="rightToEdit"
                       class="radioBtn"
                       src="./assets/images/icons/radioUnselected.svg"/>

                  <span translate>T_COLLABORATIVE_SHARE_READ</span>

                  <span class="se-icons info"
                        container="body"
                        tooltip="{{'T_SHARE_READ_TOOLTIP' | translate}}">
                    information_circle
                  </span>
                </label>
              </div>
            </div>

            <!-- Comment -->
            <div class="form-group has-feedback row">
              <label class="col-3 control-label text-left"
                     for="comment"
                     translate>
                T_COLLABORATIVE_SHARE_COMMENT
              </label>

              <div class="col-9">
                <textarea [(ngModel)]="comment"
                          [placeholder]="'T_COLLABORATIVE_SHARE_ENTER_YOUR_COMMENT' | translate"
                          class="field form-control comment-area"
                          formControlName="comment"
                          id="comment">
                </textarea>
              </div>
            </div>

          </form>
        </div>

        <div class="modal-footer background-white">
          <button (click)="hide()"
                  class="btn btn-default-white-background"
                  translate>
            T_BUTTON_CLOSE
          </button>

          <button (click)="clickShareButton()"
                  [disabled]="!form.valid"
                  class="btn btn-default-white-background"
                  translate>
            T_COLLABORATIVE_SHARE
          </button>
        </div>
      </ng-template>

    </div>
  </div>
</div>
